/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionPriceInterval } from './SubscriptionPriceInterval';
import {
    SubscriptionPriceIntervalFromJSON,
    SubscriptionPriceIntervalFromJSONTyped,
    SubscriptionPriceIntervalToJSON,
    SubscriptionPriceIntervalToJSONTyped,
} from './SubscriptionPriceInterval';

/**
 * 
 * @export
 * @interface SubscriptionPrice
 */
export interface SubscriptionPrice {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPrice
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPrice
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPrice
     */
    stripePriceId: string;
    /**
     * 
     * @type {SubscriptionPriceInterval}
     * @memberof SubscriptionPrice
     */
    interval: SubscriptionPriceInterval;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPrice
     */
    intervalCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPrice
     */
    isActive: boolean;
}



/**
 * Check if a given object implements the SubscriptionPrice interface.
 */
export function instanceOfSubscriptionPrice(value: object): value is SubscriptionPrice {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('stripePriceId' in value) || value['stripePriceId'] === undefined) return false;
    if (!('interval' in value) || value['interval'] === undefined) return false;
    if (!('intervalCount' in value) || value['intervalCount'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function SubscriptionPriceFromJSON(json: any): SubscriptionPrice {
    return SubscriptionPriceFromJSONTyped(json, false);
}

export function SubscriptionPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'price': json['price'],
        'stripePriceId': json['stripePriceId'],
        'interval': SubscriptionPriceIntervalFromJSON(json['interval']),
        'intervalCount': json['intervalCount'],
        'isActive': json['isActive'],
    };
}

export function SubscriptionPriceToJSON(json: any): SubscriptionPrice {
    return SubscriptionPriceToJSONTyped(json, false);
}

export function SubscriptionPriceToJSONTyped(value?: SubscriptionPrice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'price': value['price'],
        'stripePriceId': value['stripePriceId'],
        'interval': SubscriptionPriceIntervalToJSON(value['interval']),
        'intervalCount': value['intervalCount'],
        'isActive': value['isActive'],
    };
}

